import React, { Component } from 'react';
import {
  Row,
  Col,
} from 'reactstrap';
import nl2br from 'react-nl2br';
import { injectIntl, intlShape } from 'react-intl';
import styled from 'styled-components';
import a from '../../assets/singer.jpg';
import b from '../../assets/koi.jpeg';
import c from '../../assets/mori-arts.jpeg';

const Container = styled.div`
  margin-top: 130px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 2rem;
`;

const SubPageTitle = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 1.75rem;
  line-height: 1.2 !important;
`;

const SubPageDescription = styled.h4`
  text-align: center;
  font-size: 1.3rem;
  margin-top: 0px;
  margin-bottom: 1.75rem;
  line-height: 1.2 !important;
`;

class Exhibition extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  render() {
    const { intl } = this.props;

    return (
      <Container className="marketing container">
        <Row className="featurette">
          <Col md={{ size: 10, offset: 1 }}>
            <Title className="featurette-heading">
              {nl2br(intl.formatMessage({
                id: 'Exhibition.1.PageTitle',
              }))}
            </Title>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 10, offset: 1 }}>
            <hr />
            <Row className="mt-5 mb-5">
              <Col md="6" className="d-flex flex-column justify-content-center">
                <SubPageTitle className="featurette-heading">
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.1.Title',
                  }))}
                </SubPageTitle>
                <SubPageDescription>
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.1.SubTitle',
                  }))}
                </SubPageDescription>
                <a
                  href="https://www.youtube.com/channel/UC8OZwOONzLPLTEmIytVaibA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: 200,
                    alignSelf: 'center',
                  }}
                >
                  YouTube
                </a>
              </Col>
              <Col md="6">
                <img
                  src={a}
                  alt="sns"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="featurette mt-4">
          <Col md={{ size: 10, offset: 1 }}>
            <Title className="featurette-heading">
              {nl2br(intl.formatMessage({
                id: 'Exhibition.2.PageTitle',
              }))}
            </Title>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={{ size: 10, offset: 1 }}>
            <Row className="mt-5 mb-5">
              <Col md="6">
                <img
                  src={b}
                  alt="exhibition"
                  className="img-fluid rounded mb-4"
                />
              </Col>
              <Col md="6" className="d-flex flex-column justify-content-center">
                <SubPageTitle className="featurette-heading">
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.2.Title',
                  }))}
                </SubPageTitle>
                <SubPageDescription>
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.2.SubTitle',
                  }))}
                </SubPageDescription>
                <a
                  href="https://twitter.com/h_isz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: 200,
                    alignSelf: 'center',
                  }}
                >
                  Twitter
                </a>
              </Col>
            </Row>
            <hr />
            <Row className="mt-5 mb-5">
              <Col md="6" className="d-flex flex-column justify-content-center">
                <SubPageTitle className="featurette-heading">
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.3.Title',
                  }))}
                </SubPageTitle>
                <SubPageDescription>
                  {nl2br(intl.formatMessage({
                    id: 'Exhibition.3.SubTitle',
                  }))}
                </SubPageDescription>
                <a
                  href="https://twitter.com/kym_kikihaha828"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: 200,
                    alignSelf: 'center',
                  }}
                >
                  Twitter
                </a>
              </Col>
              <Col md="6">
                <img
                  src={c}
                  alt="sns"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default injectIntl(Exhibition);
